"use strict";
'kiwi public';

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/trim"));
var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/assign"));
var _stringify = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/json/stringify"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _lodash = _interopRequireDefault(require("lodash"));
var Misc = _interopRequireWildcard(require("@/helpers/Misc"));
var _Logger = _interopRequireDefault(require("@/libs/Logger"));
var _BouncerProvider = _interopRequireDefault(require("@/libs/BouncerProvider"));
var _Captcha = _interopRequireDefault(require("@/components/Captcha"));
var _CommonLayout = _interopRequireDefault(require("./CommonLayout"));
function _interopRequireWildcard(e, t) { if ("function" == typeof _WeakMap) var r = new _WeakMap(), n = new _WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && _Object$getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var log = _Logger.default.namespace('Welcome.vue');
var _default = exports.default = {
  components: {
    Captcha: _Captcha.default,
    StartupLayout: _CommonLayout.default
  },
  data: function data() {
    return {
      connectErrors: [],
      network: null,
      channel: '',
      nick: '',
      password: '',
      showChannel: true,
      showPass: true,
      toggablePass: true,
      showNick: true,
      show_password_box: false,
      connectWithoutChannel: false,
      showPlainText: false,
      captchaReady: false,
      termsAccepted: false,
      selectedGender: 'n',
      saslJwtToken: '',
      urlAutoConnect: false
    };
  },
  computed: {
    isIframe: function isIframe() {
      return !(window === window.parent || window.opener);
    },
    startupOptions: function startupOptions() {
      return this.$state.settings.startupOptions;
    },
    greetingText: function greetingText() {
      var greeting = this.$state.settings.startupOptions.greetingText;
      return typeof greeting === 'string' ? greeting : this.$t('start_greeting');
    },
    footerText: function footerText() {
      var footer = this.$state.settings.startupOptions.footerText;
      return typeof footer === 'string' ? footer : '';
    },
    termsContent: function termsContent() {
      var terms = this.$state.settings.startupOptions.termsContent;
      return typeof terms === 'string' ? terms : '';
    },
    buttonText: function buttonText() {
      var greeting = this.$state.settings.startupOptions.buttonText;
      return typeof greeting === 'string' ? greeting : this.$t('start_button');
    },
    genderOptions: function genderOptions() {
      return [{
        value: 'h',
        label: '🕺 Hombre'
      }, {
        value: 'm',
        label: '🌸 Mujer'
      }, {
        value: 'o',
        label: '🌈 Diverso'
      }, {
        value: 'n',
        label: '🙂 Libre'
      }];
    },
    isNickValid: function isNickValid() {
      var nickPatternStr = this.$state.setting('startupOptions.nick_format');
      var nickPattern = '';
      if (!nickPatternStr) {
        nickPattern = /^[a-z_\\[\]{}^`|][a-z0-9_\-\\[\]{}^`|]*$/i;
      } else {
        var pattern = '';
        var flags = '';
        if (nickPatternStr[0] === '/') {
          var pos = nickPatternStr.lastIndexOf('/');
          pattern = nickPatternStr.substring(1, pos);
          flags = nickPatternStr.substr(pos + 1);
        } else {
          pattern = _lodash.default.escapeRegExp(nickPatternStr);
          flags = 'i';
        }
        try {
          nickPattern = new RegExp(pattern, flags);
        } catch (error) {
          log.error('Nick format error: ' + error.message);
          return false;
        }
      }
      return this.nick.match(nickPattern);
    },
    readyToStart: function readyToStart() {
      var ready = !!this.nick;
      if (!this.connectWithoutChannel && !this.channel) {
        ready = false;
      }
      if (!this.connectWithoutChannel) {
        var bufferObjs = Misc.extractBuffers(this.channel);
        bufferObjs.forEach(function (bufferObj) {
          if ('#&'.indexOf(bufferObj.name[0]) === -1) {
            ready = false;
          }
        });
      }
      if (!this.toggablePass && !this.password && !this.saslJwtToken) {
        ready = false;
      }
      if (!this.isNickValid) {
        ready = false;
      }
      if (this.termsContent && !this.termsAccepted) {
        ready = false;
      }
      return ready;
    }
  },
  watch: {
    show_password_box: function show_password_box(newVal) {
      if (newVal === false && !this.saslJwtToken) {
        this.password = '';
      }
    }
  },
  created: function created() {
    var _context;
    var options = this.startupOptions;
    var connectOptions = this.connectOptions();
    var urlAutoConnectValue = String(Misc.queryStringVal('autoconnect') || '').toLowerCase();
    this.urlAutoConnect = ['1', 'true', 'yes', 'si', 'sí'].indexOf(urlAutoConnectValue) !== -1;
    this.saslJwtToken = (0, _trim.default)(_lodash.default).call(_lodash.default, Misc.queryStringVal('sasl_jwt') || '');
    var previousNet = null;
    if ((0, _trim.default)(_context = connectOptions.hostname).call(_context)) {
      var _context2;
      previousNet = this.$state.getNetworkFromAddress((0, _trim.default)(_context2 = connectOptions.hostname).call(_context2));
    }
    if (previousNet && previousNet.connection.nick && !Misc.queryStringVal('nick')) {
      this.nick = previousNet.connection.nick;
    } else if (Misc.queryStringVal('nick')) {
      this.nick = Misc.queryStringVal('nick');
    } else {
      this.nick = options.nick;
    }
    this.nick = this.processNickRandomNumber(this.nick || '');
    if (this.saslJwtToken) {
      this.password = this.saslJwtToken;
      this.show_password_box = false;
    } else if (options.password) {
      this.password = options.password;
    } else if (previousNet && previousNet.password) {
      this.password = previousNet.password;
      this.show_password_box = true;
    } else {
      this.password = '';
    }
    this.channel = decodeURIComponent(window.location.hash) || options.channel || '';
    if (Misc.queryStringVal('channel')) {
      this.channel = Misc.queryStringVal('channel');
    }
    this.showChannel = typeof options.showChannel === 'boolean' ? options.showChannel : true;
    this.showNick = typeof options.showNick === 'boolean' ? options.showNick : true;
    this.showPass = typeof options.showPassword === 'boolean' ? options.showPassword : true;
    this.toggablePass = typeof options.toggablePassword === 'boolean' ? options.toggablePassword : true;
    if (this.saslJwtToken) {
      this.showPass = false;
      this.toggablePass = true;
      this.show_password_box = false;
    }
    this.connectWithoutChannel = !!options.allowNoChannel;
    if (options.bouncer) {
      this.toggablePass = false;
      this.showPass = true;
      this.showChannel = false;
      this.connectWithoutChannel = true;
      var bouncer = new _BouncerProvider.default(this.$state);
      bouncer.enable(connectOptions.hostname, connectOptions.port, connectOptions.tls, connectOptions.direct, connectOptions.direct_path);
    }
    try {
      var savedGender = localStorage.getItem('chatlatinos_gender');
      if (['h', 'm', 'o', 'n'].indexOf(savedGender) !== -1) {
        this.selectedGender = savedGender;
      }
    } catch (error) {}
    if ((options.autoConnect || this.urlAutoConnect) && this.readyToStart) {
      this.startUp();
    }
  },
  methods: {
    genderCodeToText: function genderCodeToText(code) {
      if (code === 'h') {
        return 'Hombre';
      }
      if (code === 'm') {
        return 'Mujer';
      }
      if (code === 'o') {
        return 'Diverso';
      }
      return 'Libre';
    },
    genderCodeToEmoji: function genderCodeToEmoji(code) {
      if (code === 'h') {
        return '🕺';
      }
      if (code === 'm') {
        return '🌸';
      }
      if (code === 'o') {
        return '🌈';
      }
      return '🙂';
    },
    profileCodeFromNick: function profileCodeFromNick(nick) {
      var source = (0, _trim.default)(_lodash.default).call(_lodash.default, nick || 'Usuario').toUpperCase();
      var chars = '23456789ABCDEFGHJKLMNPQRSTUVWXYZ';
      var total = 0;
      for (var i = 0; i < source.length; i++) {
        total = (total * 33 + source.charCodeAt(i) + i) % 1048576;
      }
      var code = '';
      for (var _i = 0; _i < 4; _i++) {
        code += chars.charAt(total % chars.length);
        total = Math.floor(total / chars.length);
      }
      return code;
    },
    cleanGecosBase: function cleanGecosBase(baseGecos) {
      var _context3;
      var base = (0, _trim.default)(_lodash.default).call(_lodash.default, baseGecos || 'WebChachi');
      base = (0, _trim.default)(_context3 = base.replace(/\|g:[hmno]/ig, '').replace(/CL-[23456789ABCDEFGHJKLMNPQRSTUVWXYZ]{4}/ig, '').replace(/🕺/g, '').replace(/🌸/g, '').replace(/🌈/g, '').replace(/🙂/g, '').replace(/\s+/g, ' ')).call(_context3);
      if (!base) {
        base = 'WebChachi';
      }
      return base;
    },
    buildGecos: function buildGecos(baseGecos) {
      var _context4, _context5;
      var base = this.cleanGecosBase(baseGecos);
      var gender = ['h', 'm', 'o', 'n'].indexOf(this.selectedGender) !== -1 ? this.selectedGender : 'n';
      var emoji = this.genderCodeToEmoji(gender);
      var code = this.profileCodeFromNick(this.nick);
      return (0, _concat.default)(_context4 = (0, _concat.default)(_context5 = "".concat(base, " ")).call(_context5, emoji, " CL-")).call(_context4, code);
    },
    onAltClose: function onAltClose(event) {
      if (event.channel) {
        this.channel = event.channel;
      }
      if (event.nick) {
        this.nick = event.nick;
      }
      if (event.password) {
        this.password = event.password;
      }
      if (event.error) {
        this.connectErrors.push(event.error);
      }
      this.$state.settings.startupOptions.altComponent = null;
    },
    readableStateError: function readableStateError(err) {
      return Misc.networkErrorMessage(err);
    },
    formSubmit: function formSubmit() {
      if (this.readyToStart) {
        this.startUp();
      }
    },
    applySaslJwtToNetwork: function applySaslJwtToNetwork(net, token) {
      if (!net || !token) {
        return;
      }
      var accountPayload = {
        account: this.nick,
        username: this.nick,
        password: token,
        mechanism: 'JWT',
        sasl_mechanism: 'JWT',
        saslMechanism: 'JWT'
      };
      net.password = token;
      net.account = accountPayload;
      net.sasl = true;
      net.sasl_mechanism = 'JWT';
      net.saslMechanism = 'JWT';
      if (net.connection) {
        net.connection.password = token;
        net.connection.account = accountPayload;
        net.connection.sasl = true;
        net.connection.sasl_mechanism = 'JWT';
        net.connection.saslMechanism = 'JWT';
      }
      if (net.ircClient && net.ircClient.options) {
        net.ircClient.options.account = accountPayload;
        net.ircClient.options.password = token;
        net.ircClient.options.sasl = true;
        net.ircClient.options.sasl_mechanism = 'JWT';
        net.ircClient.options.saslMechanism = 'JWT';
      }
    },
    startUp: function startUp() {
      var _this = this;
      this.connectErrors = [];
      var options = (0, _assign.default)({}, this.$state.settings.startupOptions);
      var connectOptions = this.connectOptions();
      var netAddress = (0, _trim.default)(_lodash.default).call(_lodash.default, connectOptions.hostname);
      var saslJwtToken = (0, _trim.default)(_lodash.default).call(_lodash.default, this.saslJwtToken || '');
      this.nick = (0, _trim.default)(_lodash.default).call(_lodash.default, this.nick || '');
      var finalGecos = this.buildGecos(options.gecos);
      try {
        var selectedEmoji = this.genderCodeToEmoji(this.selectedGender);
        localStorage.setItem('chatlatinos_gender', this.selectedGender);
        localStorage.setItem('chatlatinos_gender_nick', this.nick.toLowerCase());
        localStorage.setItem('chatlatinos_emoji', selectedEmoji);
        localStorage.setItem('chatlatinos_profile_emoji', selectedEmoji);
        localStorage.setItem('chatlatinos_gender_emoji', selectedEmoji);
        localStorage.setItem('chatlatinos_profile', (0, _stringify.default)({
          nick: this.nick.toLowerCase(),
          gender: this.selectedGender,
          emoji: selectedEmoji,
          gecos: finalGecos,
          profileCode: this.profileCodeFromNick(this.nick),
          updatedAt: Date.now()
        }));
      } catch (error) {
        log.error('Could not save gender preference: ' + error.message);
      }
      var net = this.network || this.$state.getNetworkFromAddress(netAddress);
      var password = saslJwtToken || this.password;
      var addNetworkOptions = {
        server: netAddress,
        port: connectOptions.port,
        tls: connectOptions.tls,
        password: password,
        encoding: (0, _trim.default)(_lodash.default).call(_lodash.default, options.encoding),
        direct: connectOptions.direct,
        path: connectOptions.direct_path || '',
        gecos: finalGecos,
        username: options.username || this.nick
      };
      if (saslJwtToken) {
        addNetworkOptions.account = {
          account: this.nick,
          username: this.nick,
          password: saslJwtToken,
          mechanism: 'JWT',
          sasl_mechanism: 'JWT',
          saslMechanism: 'JWT'
        };
        addNetworkOptions.sasl = true;
        addNetworkOptions.sasl_mechanism = 'JWT';
        addNetworkOptions.saslMechanism = 'JWT';
      }
      net = net || this.$state.addNetwork('Network', this.nick, addNetworkOptions);
      net.serverBuffer().clearMessages();
      net.connection.nick = this.nick;
      net.connection.gecos = finalGecos;
      if (saslJwtToken) {
        this.applySaslJwtToNetwork(net, saslJwtToken);
      } else if (options.bouncer) {
        var _context6;
        net.connection.password = (0, _concat.default)(_context6 = "".concat(this.nick, ":")).call(_context6, password);
        net.password = '';
      } else {
        net.connection.password = '';
        net.password = password;
      }
      if ((0, _trim.default)(_lodash.default).call(_lodash.default, options.encoding || '')) {
        net.connection.encoding = (0, _trim.default)(_lodash.default).call(_lodash.default, options.encoding);
      }
      this.network = net;
      var hasSwitchedActiveBuffer = false;
      var bufferObjs = Misc.extractBuffers(this.channel);
      bufferObjs.forEach(function (bufferObj) {
        var newBuffer = _this.$state.addBuffer(net.id, bufferObj.name);
        newBuffer.enabled = true;
        if (newBuffer && !hasSwitchedActiveBuffer) {
          _this.$state.setActiveBuffer(net.id, newBuffer.name);
          hasSwitchedActiveBuffer = true;
        }
        if (bufferObj.key) {
          newBuffer.key = bufferObj.key;
        }
      });
      if (!options.bouncer && !hasSwitchedActiveBuffer) {
        this.$state.setActiveBuffer(net.id, net.serverBuffer().name);
      }
      net.ircClient.connect();
      var _onRegistered = function onRegistered() {
        if (_this.$refs.layout) {
          _this.$refs.layout.close();
        }
        if (saslJwtToken) {
          _this.cleanAuthUrl();
        }
        net.ircClient.off('registered', _onRegistered);
        net.ircClient.off('close', _onClosed);
        net.ircClient.off('irc error', onError);
      };
      var _onClosed = function onClosed() {
        var _context7;
        var lastError = _this.network.last_error;
        if (lastError && !(0, _includes.default)(_context7 = _this.connectErrors).call(_context7, lastError)) {
          _this.connectErrors.push(lastError);
        }
        net.ircClient.off('registered', _onRegistered);
        net.ircClient.off('close', _onClosed);
        net.ircClient.off('irc error', onError);
      };
      var onError = function onError(event) {
        var _context8;
        if (!event.reason || (0, _includes.default)(_context8 = _this.connectErrors).call(_context8, event.reason)) {
          return;
        }
        _this.connectErrors.push(event.reason);
      };
      net.ircClient.once('registered', _onRegistered);
      net.ircClient.once('close', _onClosed);
      net.ircClient.on('irc error', onError);
    },
    cleanAuthUrl: function cleanAuthUrl() {
      try {
        var _context9;
        var cleanUrl = (0, _concat.default)(_context9 = "".concat(window.location.origin)).call(_context9, window.location.pathname);
        window.history.replaceState({}, document.title, cleanUrl);
      } catch (error) {}
    },
    processNickRandomNumber: function processNickRandomNumber(nick) {
      var tmp = (nick || '').replace(/\?/g, function () {
        return Math.floor(Math.random() * 100).toString();
      });
      return (0, _trim.default)(_lodash.default).call(_lodash.default, tmp);
    },
    handleCaptcha: function handleCaptcha(isReady) {
      this.captchaReady = isReady;
    },
    connectOptions: function connectOptions() {
      var options = (0, _assign.default)({}, this.$state.settings.startupOptions);
      var connectOptions = Misc.connectionInfoFromConfig(options);
      connectOptions.hostname = connectOptions.hostname || 'default';
      if (!connectOptions.port && connectOptions.direct) {
        connectOptions.port = connectOptions.tls ? 443 : 80;
      } else if (!connectOptions.port && !connectOptions.direct) {
        connectOptions.port = connectOptions.tls ? 6697 : 6667;
      }
      return connectOptions;
    }
  }
};
window._kiwi_exports = window._kiwi_exports || {};
if(!window._kiwi_exports["components"]) window._kiwi_exports["components"] = {};
if(!window._kiwi_exports["components"]["startups"]) window._kiwi_exports["components"]["startups"] = {};
window._kiwi_exports["components"]["startups"]["Welcome"]
window._kiwi_exports.components.startups.Welcome = exports.default ? exports.default : exports;
